import { z } from 'zod';
/** The ten launch languages (FR-SET-03, AC-SET-03.1). Arabic ⇒ RTL (NFR-09). */
export const Language = z.enum(['en', 'fr', 'ru', 'hi', 'ar', 'es', 'nl', 'de', 'ja', 'it']);
export const RTL_LANGUAGES = ['ar'];
/** Per-category push/in-app toggles (FR-NOTF-07, US-SET-01). */
export const NotificationPrefs = z.object({
    comments: z.boolean().default(true),
    opvs: z.boolean().default(true),
    reactions: z.boolean().default(true),
    connections: z.boolean().default(true),
    supporters: z.boolean().default(true),
    admin: z.boolean().default(true),
});
export const DEFAULT_NOTIFICATION_PREFS = {
    comments: true,
    opvs: true,
    reactions: true,
    connections: true,
    supporters: true,
    admin: true,
};
export const Settings = z.object({
    language: Language.default('en'),
    notifications: NotificationPrefs.default(DEFAULT_NOTIFICATION_PREFS),
    /** FR-NOTF-04: "Turn off notification about <name>" — muted, not blocked. */
    mutedUserIds: z.array(z.string()).default([]),
});
export const UpdateSettingsInput = Settings.partial();
export const MuteState = z.object({ userId: z.string(), muted: z.boolean() });
//# sourceMappingURL=settings.js.map